/** Share only the canonical seeded public game address. Personal picture practice
 * never reaches this helper. Native cancellation is silent; clipboard fallback
 * reports success only after the write resolves. */
export async function shareGame(ctx, game, seed, engineVersion, challenge = null) {
  const url = new URL('/play.html', location.origin);
  url.searchParams.set('game', game.id);
  url.searchParams.set('seed', String(seed));
  url.searchParams.set('v', engineVersion);
  if (challenge) {
    url.searchParams.set('period', challenge.period);
    url.searchParams.set('challenge', challenge.id);
  }
  const data = { title: game.title + ' · myAudience', text: game.description, url: url.href };
  try {
    if (navigator.share) await navigator.share(data);
    else {
      await navigator.clipboard.writeText(url.href);
      ctx.toast('Game link copied.');
    }
  } catch (error) {
    if (error.name !== 'AbortError')
      ctx.toast('Sharing is unavailable. Open this game to copy its address.');
  }
}
